var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M20 20a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2zM18 2a1 1 0 0 1 1 1v8a7 7 0 1 1-14 0V3a1 1 0 0 1 2 0v8a5 5 0 1 0 10 0V3a1 1 0 0 1 1-1z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }